import { PaymentProcessorEnum } from '@systemeio/ui-frontend'
import type { AxiosResponse } from 'axios'
import { httpClient } from 'shared/api/http-client'
import { PaystackPaymentProcessor } from 'modules/profile/manage-subscriptions/types/payments-interface'

export const MANAGE_SUBSCRIPTIONS_API = '/api/settings/customer-subscriptions'
export const PAYMENT_INTEGRATION_API = '/api/payment/integration'

export const defaultCancelSubscriptionHandler = (id: number): Promise<AxiosResponse> =>
  httpClient.post(`${MANAGE_SUBSCRIPTIONS_API}/unsubscribe/${id}`)

export const cancelSecureAndPaySubscription = (id: number): Promise<AxiosResponse> =>
  httpClient.delete(`${PAYMENT_INTEGRATION_API}/secure-and-pay/subscription/cancel/${id}`)

export const cancelGocardlessSubscription = (id: number): Promise<AxiosResponse> =>
  httpClient.post(`${PAYMENT_INTEGRATION_API}/gocardless/subscription/cancel`, {
    subscription: id,
    cancelledManually: true,
    cancelledImmediately: true,
  })

export const cancelXenditSubscription = (id: number): Promise<AxiosResponse> =>
  httpClient.delete(`${PAYMENT_INTEGRATION_API}/xendit/subscription/cancel/${id}/immediately`)

export const cancelPaystackSubscription = (
  id: number,
  paymentProcessorName: PaystackPaymentProcessor,
): Promise<AxiosResponse> =>
  httpClient.delete(
    `${PAYMENT_INTEGRATION_API}/${paymentProcessorName}/subscription/cancel/${id}/immediately`,
  )

export const cancelPaypalRestSubscription = (id: number): Promise<AxiosResponse> =>
  httpClient.delete(`${PAYMENT_INTEGRATION_API}/paypal-rest/subscription/cancel/${id}`)

export const cancelSubscription = (
  subscriptionId: number,
  subscriptionItemId: number,
  paymentProcessor: PaymentProcessorEnum,
): Promise<AxiosResponse> => {
  switch (paymentProcessor) {
    case PaymentProcessorEnum.Gocardless: {
      return cancelGocardlessSubscription(subscriptionId)
    }
    case PaymentProcessorEnum.XenditPH:
    case PaymentProcessorEnum.XenditID: {
      return cancelXenditSubscription(subscriptionId)
    }
    case PaymentProcessorEnum.PaystackZA:
    case PaymentProcessorEnum.PaystackKE:
    case PaymentProcessorEnum.PaystackEG:
    case PaymentProcessorEnum.PaystackNG:
    case PaymentProcessorEnum.PaystackGH:
    case PaymentProcessorEnum.PaystackCI: {
      return cancelPaystackSubscription(subscriptionId, paymentProcessor)
    }
    case PaymentProcessorEnum.PaypalRest: {
      return cancelPaypalRestSubscription(subscriptionId)
    }
    case PaymentProcessorEnum.SecureAndPay: {
      return cancelSecureAndPaySubscription(subscriptionId)
    }
    default: {
      return defaultCancelSubscriptionHandler(subscriptionItemId)
    }
  }
}
